import type { FC } from 'react';

import Layout from 'components/Layout';
import Vault from 'containers/vault';

const App: FC = () => (
    <Layout>
      <Vault />
    </Layout>
  );

export default App;
